import { FC } from 'react';
import classNames from 'classnames';
import Link from 'next/link';
import { PrismicRichText } from '@prismicio/react';
import {
  BlogPostsSliceDefaultItem,
  BlogPostsSliceDefaultPrimary,
} from '@/types';
import {
  BlogFigureImage,
  BlogPublishDate,
  BlogStatsContainer,
} from '../Blog.components';

import style from '../blog.module.scss';

const DefaultVariation: FC<IDefaultVariationProps> = ({ items }) => {
  return (
    <div
      className={classNames(
        style.blogs__articles,
        style.blogs__articles_default,
      )}
    >
      {items.map((item, index) => {
        const {
          title,
          description,
          date,
          link,
          image,
          total_views,
          total_comments,
        } = item;
        return (
          <article key={`default-${index}`}>
            <Link className={style.article} href={link || ''}>
              <BlogFigureImage image={image} />
              <BlogPublishDate publishAt={date} />
              <blockquote>
                <PrismicRichText field={title} />
                <PrismicRichText field={description} />
                <BlogStatsContainer
                  comments={total_comments!}
                  reviews={total_views!}
                />
              </blockquote>
            </Link>
          </article>
        );
      })}
    </div>
  );
};

interface IDefaultVariationProps {
  primary: BlogPostsSliceDefaultPrimary;
  items: BlogPostsSliceDefaultItem[];
}

export default DefaultVariation;
